import {Button, Card, Col, FormControl, FormGroup, Row} from 'react-bootstrap';
import DateTime from 'react-datetime';

const GroupsSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Card className="admin-search-filter">
      <Card.Body>
        <Row>
          <Col md={3}>
            <FormGroup>
              Group name
              <FormControl
                onChange={props.onNameChange}
                onKeyPress={doSearch}
                placeholder="Group name keyword"
                value={props.nameValue}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              Created after date
              <DateTime
                timeFormat={false}
                dateFormat="DD/MM/YYYY"
                value={props.dateFromValue}
                onChange={props.onDateFromChange}
                closeOnSelect
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              Created before date
              <DateTime
                timeFormat={false}
                dateFormat="DD/MM/YYYY"
                value={props.dateToValue}
                onChange={props.onDateToChange}
                closeOnSelect
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="actions">
            <Button
              className="red-ghost-btn"
              onClick={props.onClear}
            >Clear search/filters
            </Button>
            <Button
              className="red-ghost-btn"
              onClick={props.onSearch}
            >Search
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default GroupsSearch;
